import React from 'react';
import EventRowMixin from 'react-big-calendar/lib/EventRowMixin';
import { monthRowSegmentFlexBasis } from './monthViewGap';

const GapAwareEventRowMixin = {
  ...EventRowMixin,
  renderSpan(slots, len, key, content = ' ') {
    const basis = monthRowSegmentFlexBasis(slots, len);
    return React.createElement('div', {
      key,
      className: 'rbc-row-segment',
      style: {
        WebkitFlexBasis: basis,
        flexBasis: basis,
        maxWidth: basis,
        minWidth: 0,
      },
    }, content);
  },
};

export default GapAwareEventRowMixin;
